/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../common/data';
import '../../customers/request';

const $root =
  $protobuf.roots['default'] ||
  ($protobuf.roots['default'] = new $protobuf.Root());

const jsonData = {
  squareup: {
    nested: {
      buyerportal: {
        nested: {
          receiptsettings: {
            nested: {
              AutoReceiptSetting: {
                values: {
                  AUTO_RECEIPT_UNKNOWN: 0,
                  AUTO_RECEIPT_OPT_IN: 1,
                  AUTO_RECEIPT_OPT_OUT: 2,
                },
              },
              CardGroupType: {
                values: {
                  CARD_GROUP_TYPE_UNKNOWN: 0,
                  SINGLE: 1,
                  SHARED_FAMILY: 2,
                  REISSUED: 3,
                },
              },
              CardFormFactor: {
                values: {
                  FORM_FACTOR_UNKNOWN: 0,
                  PHYSICAL: 1,
                  DIGITAL_WALLET_APPLE_PAY: 2,
                  DIGITAL_WALLET_GOOGLE_PAY: 3,
                  DIGITAL_WALLET_OTHER: 4,
                },
              },
              CardInstance: {
                fields: {
                  id: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  panSequenceNumber: {
                    type: 'string',
                    id: 2,
                    rule: 'optional',
                  },
                  formFactor: {
                    type: '.squareup.buyerportal.receiptsettings.CardFormFactor',
                    id: 3,
                    rule: 'optional',
                  },
                  cardholderName: {
                    type: 'string',
                    id: 4,
                    rule: 'optional',
                  },
                  expiration: {
                    type: 'string',
                    id: 5,
                    rule: 'optional',
                  },
                  isActive: {
                    type: 'bool',
                    id: 6,
                    rule: 'optional',
                  },
                },
              },
              CardGroup: {
                fields: {
                  paymentAccountReference: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  brand: {
                    type: 'string',
                    id: 2,
                    rule: 'optional',
                  },
                  lastFour: {
                    type: 'string',
                    id: 3,
                    rule: 'optional',
                  },
                  type: {
                    type: '.squareup.buyerportal.receiptsettings.CardGroupType',
                    id: 4,
                    rule: 'optional',
                  },
                  instances: {
                    type: '.squareup.buyerportal.receiptsettings.CardInstance',
                    id: 5,
                    rule: 'repeated',
                  },
                },
              },
              MerchantReceiptOverride: {
                fields: {
                  merchant: {
                    type: '.squareup.buyerportal.common.MerchantInfo',
                    id: 1,
                    rule: 'optional',
                  },
                  setting: {
                    type: '.squareup.buyerportal.receiptsettings.AutoReceiptSetting',
                    id: 2,
                    rule: 'optional',
                  },
                },
              },
              CardReceiptPreferences: {
                fields: {
                  id: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  panSequenceNumber: {
                    type: 'string',
                    id: 2,
                    rule: 'optional',
                  },
                  autoReceiptSetting: {
                    type: '.squareup.buyerportal.receiptsettings.AutoReceiptSetting',
                    id: 3,
                    rule: 'optional',
                  },
                  merchantOverrides: {
                    type: '.squareup.buyerportal.receiptsettings.MerchantReceiptOverride',
                    id: 4,
                    rule: 'repeated',
                  },
                },
              },
              RetrieveReceiptSettingsRequest: {
                fields: {},
              },
              RetrieveReceiptSettingsResponse: {
                fields: {
                  status: {
                    type: '.squareup.customers.request.RequestStatus',
                    id: 1,
                    rule: 'optional',
                  },
                  errors: {
                    type: '.squareup.customers.request.RequestError',
                    id: 2,
                    rule: 'repeated',
                  },
                  cardGroups: {
                    type: '.squareup.buyerportal.receiptsettings.CardGroup',
                    id: 3,
                    rule: 'repeated',
                  },
                  preferences: {
                    type: '.squareup.buyerportal.receiptsettings.CardReceiptPreferences',
                    id: 4,
                    rule: 'repeated',
                  },
                },
              },
              UpdateAutoReceiptSettingRequest: {
                fields: {
                  cardId: {
                    type: 'string',
                    id: 1,
                    rule: 'optional',
                  },
                  panSequenceNumber: {
                    type: 'string',
                    id: 2,
                    rule: 'optional',
                  },
                  setting: {
                    type: '.squareup.buyerportal.receiptsettings.AutoReceiptSetting',
                    id: 3,
                    rule: 'optional',
                  },
                  merchantId: {
                    type: 'string',
                    id: 4,
                    rule: 'optional',
                  },
                },
              },
              UpdateAutoReceiptSettingResponse: {
                fields: {
                  status: {
                    type: '.squareup.customers.request.RequestStatus',
                    id: 1,
                    rule: 'optional',
                  },
                  errors: {
                    type: '.squareup.customers.request.RequestError',
                    id: 2,
                    rule: 'repeated',
                  },
                },
              },
              ReceiptSettingsService: {
                methods: {
                  RetrieveReceiptSettings: {
                    requestType:
                      '.squareup.buyerportal.receiptsettings.RetrieveReceiptSettingsRequest',
                    responseType:
                      '.squareup.buyerportal.receiptsettings.RetrieveReceiptSettingsResponse',
                  },
                  UpdateAutoReceiptSetting: {
                    requestType:
                      '.squareup.buyerportal.receiptsettings.UpdateAutoReceiptSettingRequest',
                    responseType:
                      '.squareup.buyerportal.receiptsettings.UpdateAutoReceiptSettingResponse',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

// Do not initialize these protos if they have already been defined
if (
  !$root.nested?.squareup?.nested?.buyerportal?.nested?.receiptsettings?.nested
    ?.ReceiptSettingsService
) {
  $root.addJSON(jsonData);
}

export const AutoReceiptSetting = $root.lookupEnum(
  'squareup.buyerportal.receiptsettings.AutoReceiptSetting'
).values;

export const CardGroupType = $root.lookupEnum(
  'squareup.buyerportal.receiptsettings.CardGroupType'
).values;

export const CardFormFactor = $root.lookupEnum(
  'squareup.buyerportal.receiptsettings.CardFormFactor'
).values;

export const CardInstance = $root.lookupType(
  'squareup.buyerportal.receiptsettings.CardInstance'
);
fixType(CardInstance, {
  id: { required: true },
});
Builder.createAndAttachToType(CardInstance);

export const CardGroup = $root.lookupType(
  'squareup.buyerportal.receiptsettings.CardGroup'
);
fixType(CardGroup, {
  paymentAccountReference: { required: true },
  brand: { required: true },
  lastFour: { required: true },
});
Builder.createAndAttachToType(CardGroup);

export const MerchantReceiptOverride = $root.lookupType(
  'squareup.buyerportal.receiptsettings.MerchantReceiptOverride'
);
fixType(MerchantReceiptOverride);
Builder.createAndAttachToType(MerchantReceiptOverride);

export const CardReceiptPreferences = $root.lookupType(
  'squareup.buyerportal.receiptsettings.CardReceiptPreferences'
);
fixType(CardReceiptPreferences, {
  id: { required: true },
});
Builder.createAndAttachToType(CardReceiptPreferences);

export const RetrieveReceiptSettingsRequest = $root.lookupType(
  'squareup.buyerportal.receiptsettings.RetrieveReceiptSettingsRequest'
);
fixType(RetrieveReceiptSettingsRequest);
Builder.createAndAttachToType(RetrieveReceiptSettingsRequest);

export const RetrieveReceiptSettingsResponse = $root.lookupType(
  'squareup.buyerportal.receiptsettings.RetrieveReceiptSettingsResponse'
);
fixType(RetrieveReceiptSettingsResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(RetrieveReceiptSettingsResponse);

export const UpdateAutoReceiptSettingRequest = $root.lookupType(
  'squareup.buyerportal.receiptsettings.UpdateAutoReceiptSettingRequest'
);
fixType(UpdateAutoReceiptSettingRequest, {
  cardId: { required: true },
  setting: { required: true },
});
Builder.createAndAttachToType(UpdateAutoReceiptSettingRequest);

export const UpdateAutoReceiptSettingResponse = $root.lookupType(
  'squareup.buyerportal.receiptsettings.UpdateAutoReceiptSettingResponse'
);
fixType(UpdateAutoReceiptSettingResponse, {
  status: { required: true },
});
Builder.createAndAttachToType(UpdateAutoReceiptSettingResponse);

export const ReceiptSettingsService = $root.lookupService(
  'squareup.buyerportal.receiptsettings.ReceiptSettingsService'
);
